import $ from "jquery";
import 'slick-carousel/slick/slick';
import './lsag.utils';

const productImageSlider = {
    productImageSlider: undefined,
    productThumbsSlider: undefined,
    productZoomImageSlider: undefined,
    cacheSelectors() {
        this.productImageSlider = $('.js-pdp-gallery');
        this.productThumbsSlider = $('.js-image-gallery__nav');
        this.productZoomImageSlider = $('.js-image-zoom__gallery');
    },
    thumbsSlide(currentSlide, nextSlide) {
        const currentImage = productImageSlider.productThumbsSlider.children()[currentSlide];
        const nextImage = productImageSlider.productThumbsSlider.children()[nextSlide];

        currentImage.classList.remove('image-gallery__nav-slide--active');
        nextImage.classList.add('image-gallery__nav-slide--active');
        nextImage.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
        });
    },
    build() {
        this.productImageSlider
            .removeClass('image-gallery--not-ready')
            .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                productImageSlider.thumbsSlide(currentSlide, nextSlide);
            })
            .slick({
                arrows: true,
                prevArrow: `
                    <button class="btn-reset slick-prev slick-arrow">
                        <svg class="icon icon-scroll-left-no-bg">
                            <use xlink:href="#icon-scroll-left-no-bg"></use>
                        </svg>
                    </button>
                `,
                nextArrow: `
                    <button class="btn-reset slick-next slick-arrow">
                        <svg class="icon icon-scroll-right-no-bg">
                            <use xlink:href="#icon-scroll-right-no-bg"></use>
                        </svg>
                    </button>
                `,
                infinite: true,
                slidesToScroll: 1,
                slidesToShow: 2,
                speed: 300,
                rows: 2,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                            rows: 1
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            rows: 1
                        }
                    },
                    {
                        breakpoint: 450,
                        settings: {
                            slidesToShow: 1,
                            rows: 1
                        }
                    }
                ]
            });
        this.productZoomImageSlider
            .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                productImageSlider.thumbsSlide(currentSlide, nextSlide);
            })
            .slick({
                arrows: true,
                prevArrow: `
                    <button class="btn-reset slick-prev slick-arrow">
                        <svg class="icon icon-scroll-left-no-bg">
                            <use xlink:href="#icon-scroll-left-no-bg"></use>
                        </svg>
                    </button>
                `,
                nextArrow: `
                    <button class="btn-reset slick-next slick-arrow">
                        <svg class="icon icon-scroll-right-no-bg">
                            <use xlink:href="#icon-scroll-right-no-bg"></use>
                        </svg>
                    </button>
                `,
                infinite: true,
                slidesToScroll: 1,
                slidesToShow: 1,
                speed: 300,
                respondTo: 'slider'
            });
    },
    bindEvents() {
        this.productImageSlider.on('click', 'figure', function () {
            let currentId = parseInt($(this).data('id'), 10);
            let $zoomGallery = $('.js-image-zoom__gallery');

            // simple deferred loading of images
            $zoomGallery.find('img').each(function () {
                let $this = $(this);
                let imageSrc = $this.data('src');
                $this.attr('src', imageSrc);
            });
            $('.image-zoom__wrapper').addClass('image-zoom__wrapper--active');
            productImageSlider.productThumbsSlider.addClass('image-gallery__nav--zoom');
            $zoomGallery.slick('slickGoTo', currentId, true);
        });

        this.productThumbsSlider.on('click', '.image-gallery__nav-slide', function () {
            let currentId = parseInt($(this).data('id'), 10);
            productImageSlider.productImageSlider.slick('slickGoTo', currentId, true);
            productImageSlider.productZoomImageSlider.slick('slickGoTo', currentId, true);
        });

        $('.image-zoom__close').on('click', function () {
            $('.image-zoom__wrapper').removeClass('image-zoom__wrapper--active');
            productImageSlider.productThumbsSlider.removeClass('image-gallery__nav--zoom');
        });
    }
};

// DOM ready
$(() => {
    productImageSlider.cacheSelectors();
    productImageSlider.build();
    productImageSlider.bindEvents();
});

export default productImageSlider;
